/* eslint-disable no-inline-styles/no-inline-styles */

import { RawImage } from '@/core/features';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';
import ZoomPanPinchWrapper from '@/core/features/zoom-pan-pinch/zoom-pan-pinch-wrapper';

type IntermapsIframeProps = {
    height: 'auto' | number;
    iframeUrl: string;
    type: 'iframe' | 'image';
};

export default function IntermapsIframe({ height, iframeUrl, type }: IntermapsIframeProps) {
    const { isDesktopView } = useDeviceoutput();
    if (type === 'image') {
        return (
            <ZoomPanPinchWrapper
                transform={{
                    contentStyle: { width: '100%' },
                    wrapperStyle: { width: '100%' },
                }}
            >
                <RawImage
                    alt={''}
                    fetchPriority={'low'}
                    height={height}
                    preload={false}
                    style={{ objectFit: isDesktopView ? undefined : 'contain', width: '100%' }}
                    url={iframeUrl}
                />
            </ZoomPanPinchWrapper>
        );
    }

    return (
        <iframe
            height={height}
            loading={'lazy'}
            src={iframeUrl}
            style={{
                border: 'none',
                marginBottom: '-4px',
                marginTop: '10px',
                overflow: 'hidden',
                width: '100%',
            }}
        />
    );
}
